const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoCompanyDistributionAreasCommand: any = {
    CargoDistributionAreaList: Backofficebff + '/v1/cargodistributionarea/get-cargo-distribution-area-list',
};
